import React from 'react'

// One card of the detail screen: a title, an optional line under it, the body.
export default function Section({ title, subtitle, actions, children, id }) {
  const headingId = id ? `${id}-title` : undefined
  return (
    <section className="card" aria-labelledby={headingId} style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
        <div>
          <h2 id={headingId} style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>{title}</h2>
          {subtitle && <p style={{ margin: '3px 0 0', fontSize: 12, color: 'var(--text-muted)' }}>{subtitle}</p>}
        </div>
        {actions}
      </div>
      {children}
    </section>
  )
}

// Key/value pairs. A missing value reads "—", never blank.
export function KeyValues({ rows, label }) {
  return (
    <dl className="li-kv" aria-label={label} style={{ margin: 0 }}>
      {rows.map(([key, value]) => (
        <React.Fragment key={key}>
          <dt>{key}</dt>
          <dd>{value === null || value === undefined || value === '' ? <span style={{ color: 'var(--text-muted)' }}>—</span> : value}</dd>
        </React.Fragment>
      ))}
    </dl>
  )
}

export function Muted({ children }) {
  return <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>{children}</p>
}
